'use client';

import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import React from 'react';

interface Props {
	title: string | null;
	content: string | null;
	type: string | null;
	handleDismiss: () => void;
	handleConfirm: () => void;
	confirmText: string | null;
	dismissText: string | null;
}

export const ConfirmationModal = ({
	title,
	content,
	type,
	handleDismiss,
	handleConfirm,
	confirmText,
	dismissText,
}: Props): React.JSX.Element => (
	<div style={{ maxHeight: '800px' }}>
		<div
			style={{
				display: 'flex',
				justifyContent: 'end',
				paddingBottom: '10px',
				alignItems: 'center',
			}}
		>
			<IconButton onClick={handleDismiss}>
				<CloseIcon />
			</IconButton>
		</div>
		<h3 style={{ padding: '0px 15px' }}>{title}</h3>
		<br />

		{type === 'application/pdf' ? (
			<object type='application/pdf' data={content} width='1000px' height='600px' />
		) : (
			<img
				style={{
					maxHeight: '100%',
					maxWidth: '100%',
					verticalAlign: 'middle',
				}}
				src={content}
				alt=''
			/>
		)}
		<div style={{ display: 'flex', justifyContent: confirmText ? 'space-between' : 'center', padding: '10px' }}>
			<Button onClick={handleDismiss}>{dismissText}</Button>
			{confirmText && <Button onClick={handleConfirm}>{confirmText}</Button>}
		</div>
	</div>
);
